// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD4Jd4o_QUVdY63X8TwM8fBjty6UHKsOtw",
  authDomain: "panaderia-29bf3.firebaseapp.com",
  projectId: "panaderia-29bf3",
  storageBucket: "panaderia-29bf3.appspot.com",
  messagingSenderId: "509324568257",
  appId: "1:509324568257:web:16e7cecd506a789b3f5640"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage();
